// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file daily_summary.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file daily_summary.proto.
 */
export const file_daily_summary: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_organization]);

/**
 * @generated from message raccoonai.VehicleTypeCount
 */
export type VehicleTypeCount = Message<"raccoonai.VehicleTypeCount"> & {
  /**
   * @generated from field: optional string type = 1;
   */
  type: string;

  /**
   * @generated from field: optional int32 count = 2;
   */
  count: number;
};

/**
 * @generated from message raccoonai.VehicleTypeCount
 */
export type VehicleTypeCountJson = {
  /**
   * @generated from field: optional string type = 1;
   */
  type?: string;

  /**
   * @generated from field: optional int32 count = 2;
   */
  count?: number;
};

/**
 * Describes the message raccoonai.VehicleTypeCount.
 * Use `create(VehicleTypeCountSchema)` to create a new message.
 */
export const VehicleTypeCountSchema: GenMessage<VehicleTypeCount, {jsonType: VehicleTypeCountJson}> = /*@__PURE__*/
  messageDesc(file_daily_summary, 0);

/**
 * @generated from message raccoonai.DistrictVolume
 */
export type DistrictVolume = Message<"raccoonai.DistrictVolume"> & {
  /**
   * @generated from field: optional uint64 summary_id = 1 [json_name = "summary_id"];
   */
  summaryId: bigint;

  /**
   * @generated from field: optional string district_name = 2 [json_name = "district_name"];
   */
  districtName: string;

  /**
   * @generated from field: optional float plan_volume = 3 [json_name = "plan_volume"];
   */
  planVolume: number;

  /**
   * @generated from field: optional float fact_volume = 4 [json_name = "fact_volume"];
   */
  factVolume: number;
};

/**
 * @generated from message raccoonai.DistrictVolume
 */
export type DistrictVolumeJson = {
  /**
   * @generated from field: optional uint64 summary_id = 1 [json_name = "summary_id"];
   */
  summary_id?: string;

  /**
   * @generated from field: optional string district_name = 2 [json_name = "district_name"];
   */
  district_name?: string;

  /**
   * @generated from field: optional float plan_volume = 3 [json_name = "plan_volume"];
   */
  plan_volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float fact_volume = 4 [json_name = "fact_volume"];
   */
  fact_volume?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.DistrictVolume.
 * Use `create(DistrictVolumeSchema)` to create a new message.
 */
export const DistrictVolumeSchema: GenMessage<DistrictVolume, {jsonType: DistrictVolumeJson}> = /*@__PURE__*/
  messageDesc(file_daily_summary, 1);

/**
 * @generated from message raccoonai.ContainerStat
 */
export type ContainerStat = Message<"raccoonai.ContainerStat"> & {
  /**
   * @generated from field: optional uint64 summary_id = 1 [json_name = "summary_id"];
   */
  summaryId: bigint;

  /**
   * @generated from field: optional string container_type = 2 [json_name = "container_type"];
   */
  containerType: string;

  /**
   * @generated from field: optional int32 plan_count = 3 [json_name = "plan_count"];
   */
  planCount: number;

  /**
   * @generated from field: optional int32 fact_count = 4 [json_name = "fact_count"];
   */
  factCount: number;
};

/**
 * @generated from message raccoonai.ContainerStat
 */
export type ContainerStatJson = {
  /**
   * @generated from field: optional uint64 summary_id = 1 [json_name = "summary_id"];
   */
  summary_id?: string;

  /**
   * @generated from field: optional string container_type = 2 [json_name = "container_type"];
   */
  container_type?: string;

  /**
   * @generated from field: optional int32 plan_count = 3 [json_name = "plan_count"];
   */
  plan_count?: number;

  /**
   * @generated from field: optional int32 fact_count = 4 [json_name = "fact_count"];
   */
  fact_count?: number;
};

/**
 * Describes the message raccoonai.ContainerStat.
 * Use `create(ContainerStatSchema)` to create a new message.
 */
export const ContainerStatSchema: GenMessage<ContainerStat, {jsonType: ContainerStatJson}> = /*@__PURE__*/
  messageDesc(file_daily_summary, 2);

/**
 * @generated from message raccoonai.VisitPointStat
 */
export type VisitPointStat = Message<"raccoonai.VisitPointStat"> & {
  /**
   * @generated from field: optional uint64 summary_id = 1 [json_name = "summary_id"];
   */
  summaryId: bigint;

  /**
   * @generated from field: optional string point_name = 2 [json_name = "point_name"];
   */
  pointName: string;

  /**
   * @generated from field: optional float volume = 3;
   */
  volume: number;
};

/**
 * @generated from message raccoonai.VisitPointStat
 */
export type VisitPointStatJson = {
  /**
   * @generated from field: optional uint64 summary_id = 1 [json_name = "summary_id"];
   */
  summary_id?: string;

  /**
   * @generated from field: optional string point_name = 2 [json_name = "point_name"];
   */
  point_name?: string;

  /**
   * @generated from field: optional float volume = 3;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.VisitPointStat.
 * Use `create(VisitPointStatSchema)` to create a new message.
 */
export const VisitPointStatSchema: GenMessage<VisitPointStat, {jsonType: VisitPointStatJson}> = /*@__PURE__*/
  messageDesc(file_daily_summary, 3);

/**
 * @generated from message raccoonai.DailySummary
 */
export type DailySummary = Message<"raccoonai.DailySummary"> & {
  /**
   * Metadata
   *
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * date as ISO string
   *
   * @generated from field: optional string report_date = 2 [json_name = "report_date"];
   */
  reportDate: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_updated = 3 [json_name = "last_updated"];
   */
  lastUpdated?: Timestamp;

  /**
   * --- newVolumesInfo Fields ---
   *
   * @generated from field: optional float vol_ordered = 4 [json_name = "vol_ordered"];
   */
  volOrdered: number;

  /**
   * @generated from field: optional float vol_nominal_handled = 5 [json_name = "vol_nominal_handled"];
   */
  volNominalHandled: number;

  /**
   * @generated from field: optional float vol_fact_handled = 6 [json_name = "vol_fact_handled"];
   */
  volFactHandled: number;

  /**
   * @generated from field: optional float vol_confirmed_fail = 7 [json_name = "vol_confirmed_fail"];
   */
  volConfirmedFail: number;

  /**
   * @generated from field: optional float vol_not_distributed = 8 [json_name = "vol_not_distributed"];
   */
  volNotDistributed: number;

  /**
   * @generated from field: optional float vol_not_visited = 9 [json_name = "vol_not_visited"];
   */
  volNotVisited: number;

  /**
   * @generated from field: optional float vol_success_percent = 10 [json_name = "vol_success_percent"];
   */
  volSuccessPercent: number;

  /**
   * @generated from field: optional float vol_failed_percent = 11 [json_name = "vol_failed_percent"];
   */
  volFailedPercent: number;

  /**
   * @generated from field: optional float vol_not_handled_percent = 12 [json_name = "vol_not_handled_percent"];
   */
  volNotHandledPercent: number;

  /**
   * --- newCountInfo Fields ---
   *
   * @generated from field: optional int32 count_ordered = 13 [json_name = "count_ordered"];
   */
  countOrdered: number;

  /**
   * @generated from field: optional int32 count_fact = 14 [json_name = "count_fact"];
   */
  countFact: number;

  /**
   * @generated from field: optional int32 count_confirmed_fail = 15 [json_name = "count_confirmed_fail"];
   */
  countConfirmedFail: number;

  /**
   * @generated from field: optional int32 count_not_distributed = 16 [json_name = "count_not_distributed"];
   */
  countNotDistributed: number;

  /**
   * @generated from field: optional int32 count_not_visited = 17 [json_name = "count_not_visited"];
   */
  countNotVisited: number;

  /**
   * @generated from field: optional float count_success_percent = 18 [json_name = "count_success_percent"];
   */
  countSuccessPercent: number;

  /**
   * @generated from field: optional float count_failed_percent = 19 [json_name = "count_failed_percent"];
   */
  countFailedPercent: number;

  /**
   * @generated from field: optional float count_not_handled_percent = 20 [json_name = "count_not_handled_percent"];
   */
  countNotHandledPercent: number;

  /**
   * --- vehicleInfo Fields ---
   *
   * @generated from field: optional int32 veh_total_count = 21 [json_name = "veh_total_count"];
   */
  vehTotalCount: number;

  /**
   * @generated from field: optional int32 veh_unit_count = 22 [json_name = "veh_unit_count"];
   */
  vehUnitCount: number;

  /**
   * @generated from field: optional int32 veh_working = 23 [json_name = "veh_working"];
   */
  vehWorking: number;

  /**
   * @generated from field: optional int32 veh_finished = 24 [json_name = "veh_finished"];
   */
  vehFinished: number;

  /**
   * @generated from field: optional int32 veh_waiting = 25 [json_name = "veh_waiting"];
   */
  vehWaiting: number;

  /**
   * @generated from field: optional int32 veh_garbage_truck_count = 26 [json_name = "veh_garbage_truck_count"];
   */
  vehGarbageTruckCount: number;

  /**
   * @generated from field: optional float veh_avg_run = 27 [json_name = "veh_avg_run"];
   */
  vehAvgRun: number;

  /**
   * @generated from field: optional int32 veh_max_run = 28 [json_name = "veh_max_run"];
   */
  vehMaxRun: number;

  /**
   * Flattened Vehicle Metrics
   *
   * @generated from field: optional float average_weighted_run = 29 [json_name = "average_weighted_run"];
   */
  averageWeightedRun: number;

  /**
   * @generated from field: optional int32 min_run = 30 [json_name = "min_run"];
   */
  minRun: number;

  /**
   * @generated from field: optional float last_run_average_percent = 31 [json_name = "last_run_average_percent"];
   */
  lastRunAveragePercent: number;

  /**
   * @generated from field: optional float last_run_max_percent = 32 [json_name = "last_run_max_percent"];
   */
  lastRunMaxPercent: number;

  /**
   * @generated from field: optional float last_run_min_percent = 33 [json_name = "last_run_min_percent"];
   */
  lastRunMinPercent: number;

  /**
   * @generated from field: optional float last_run_average_weighted_percent = 34 [json_name = "last_run_average_weighted_percent"];
   */
  lastRunAverageWeightedPercent: number;

  /**
   * JSONB field
   *
   * @generated from field: repeated raccoonai.VehicleTypeCount veh_type_counts = 35 [json_name = "veh_type_counts"];
   */
  vehTypeCounts: VehicleTypeCount[];

  /**
   * --- dayHandlingStands Fields ---
   *
   * @generated from field: optional int32 stands_plan = 36 [json_name = "stands_plan"];
   */
  standsPlan: number;

  /**
   * @generated from field: optional int32 stands_visited = 37 [json_name = "stands_visited"];
   */
  standsVisited: number;

  /**
   * @generated from field: optional int32 stands_gps_confirmed = 38 [json_name = "stands_gps_confirmed"];
   */
  standsGpsConfirmed: number;

  /**
   * @generated from field: optional int32 stands_not_gps_confirmed = 39 [json_name = "stands_not_gps_confirmed"];
   */
  standsNotGpsConfirmed: number;

  /**
   * @generated from field: optional int32 stands_not_visited = 40 [json_name = "stands_not_visited"];
   */
  standsNotVisited: number;

  /**
   * @generated from field: optional float stands_visited_percent = 41 [json_name = "stands_visited_percent"];
   */
  standsVisitedPercent: number;

  /**
   * @generated from field: optional int32 stands_climb_count = 42 [json_name = "stands_climb_count"];
   */
  standsClimbCount: number;

  /**
   * @generated from field: optional int32 stands_visit_count = 43 [json_name = "stands_visit_count"];
   */
  standsVisitCount: number;

  /**
   * Relationships
   *
   * @generated from field: repeated raccoonai.DistrictVolume district_volumes = 44 [json_name = "district_volumes"];
   */
  districtVolumes: DistrictVolume[];

  /**
   * @generated from field: repeated raccoonai.ContainerStat container_stats = 45 [json_name = "container_stats"];
   */
  containerStats: ContainerStat[];

  /**
   * @generated from field: repeated raccoonai.VisitPointStat visit_point_stats = 46 [json_name = "visit_point_stats"];
   */
  visitPointStats: VisitPointStat[];

  /**
   * The organization the row rolls up to (owner_organization_id resolved), so the caller
   * does not have to look the name up separately.
   *
   * @generated from field: optional raccoonai.Organization owner_organization = 47 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * The district organization whose geo access covers that organization, and that access's
   * area name. Both unset when the organization's branches span several districts - there is
   * no single district to name then.
   *
   * @generated from field: optional uint64 district_organization_id = 48 [json_name = "district_organization_id"];
   */
  districtOrganizationId: bigint;

  /**
   * @generated from field: optional string district_name = 49 [json_name = "district_name"];
   */
  districtName: string;
};

/**
 * @generated from message raccoonai.DailySummary
 */
export type DailySummaryJson = {
  /**
   * Metadata
   *
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * date as ISO string
   *
   * @generated from field: optional string report_date = 2 [json_name = "report_date"];
   */
  report_date?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_updated = 3 [json_name = "last_updated"];
   */
  last_updated?: TimestampJson;

  /**
   * --- newVolumesInfo Fields ---
   *
   * @generated from field: optional float vol_ordered = 4 [json_name = "vol_ordered"];
   */
  vol_ordered?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float vol_nominal_handled = 5 [json_name = "vol_nominal_handled"];
   */
  vol_nominal_handled?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float vol_fact_handled = 6 [json_name = "vol_fact_handled"];
   */
  vol_fact_handled?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float vol_confirmed_fail = 7 [json_name = "vol_confirmed_fail"];
   */
  vol_confirmed_fail?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float vol_not_distributed = 8 [json_name = "vol_not_distributed"];
   */
  vol_not_distributed?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float vol_not_visited = 9 [json_name = "vol_not_visited"];
   */
  vol_not_visited?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float vol_success_percent = 10 [json_name = "vol_success_percent"];
   */
  vol_success_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float vol_failed_percent = 11 [json_name = "vol_failed_percent"];
   */
  vol_failed_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float vol_not_handled_percent = 12 [json_name = "vol_not_handled_percent"];
   */
  vol_not_handled_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * --- newCountInfo Fields ---
   *
   * @generated from field: optional int32 count_ordered = 13 [json_name = "count_ordered"];
   */
  count_ordered?: number;

  /**
   * @generated from field: optional int32 count_fact = 14 [json_name = "count_fact"];
   */
  count_fact?: number;

  /**
   * @generated from field: optional int32 count_confirmed_fail = 15 [json_name = "count_confirmed_fail"];
   */
  count_confirmed_fail?: number;

  /**
   * @generated from field: optional int32 count_not_distributed = 16 [json_name = "count_not_distributed"];
   */
  count_not_distributed?: number;

  /**
   * @generated from field: optional int32 count_not_visited = 17 [json_name = "count_not_visited"];
   */
  count_not_visited?: number;

  /**
   * @generated from field: optional float count_success_percent = 18 [json_name = "count_success_percent"];
   */
  count_success_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float count_failed_percent = 19 [json_name = "count_failed_percent"];
   */
  count_failed_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float count_not_handled_percent = 20 [json_name = "count_not_handled_percent"];
   */
  count_not_handled_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * --- vehicleInfo Fields ---
   *
   * @generated from field: optional int32 veh_total_count = 21 [json_name = "veh_total_count"];
   */
  veh_total_count?: number;

  /**
   * @generated from field: optional int32 veh_unit_count = 22 [json_name = "veh_unit_count"];
   */
  veh_unit_count?: number;

  /**
   * @generated from field: optional int32 veh_working = 23 [json_name = "veh_working"];
   */
  veh_working?: number;

  /**
   * @generated from field: optional int32 veh_finished = 24 [json_name = "veh_finished"];
   */
  veh_finished?: number;

  /**
   * @generated from field: optional int32 veh_waiting = 25 [json_name = "veh_waiting"];
   */
  veh_waiting?: number;

  /**
   * @generated from field: optional int32 veh_garbage_truck_count = 26 [json_name = "veh_garbage_truck_count"];
   */
  veh_garbage_truck_count?: number;

  /**
   * @generated from field: optional float veh_avg_run = 27 [json_name = "veh_avg_run"];
   */
  veh_avg_run?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional int32 veh_max_run = 28 [json_name = "veh_max_run"];
   */
  veh_max_run?: number;

  /**
   * Flattened Vehicle Metrics
   *
   * @generated from field: optional float average_weighted_run = 29 [json_name = "average_weighted_run"];
   */
  average_weighted_run?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional int32 min_run = 30 [json_name = "min_run"];
   */
  min_run?: number;

  /**
   * @generated from field: optional float last_run_average_percent = 31 [json_name = "last_run_average_percent"];
   */
  last_run_average_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float last_run_max_percent = 32 [json_name = "last_run_max_percent"];
   */
  last_run_max_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float last_run_min_percent = 33 [json_name = "last_run_min_percent"];
   */
  last_run_min_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float last_run_average_weighted_percent = 34 [json_name = "last_run_average_weighted_percent"];
   */
  last_run_average_weighted_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * JSONB field
   *
   * @generated from field: repeated raccoonai.VehicleTypeCount veh_type_counts = 35 [json_name = "veh_type_counts"];
   */
  veh_type_counts?: VehicleTypeCountJson[];

  /**
   * --- dayHandlingStands Fields ---
   *
   * @generated from field: optional int32 stands_plan = 36 [json_name = "stands_plan"];
   */
  stands_plan?: number;

  /**
   * @generated from field: optional int32 stands_visited = 37 [json_name = "stands_visited"];
   */
  stands_visited?: number;

  /**
   * @generated from field: optional int32 stands_gps_confirmed = 38 [json_name = "stands_gps_confirmed"];
   */
  stands_gps_confirmed?: number;

  /**
   * @generated from field: optional int32 stands_not_gps_confirmed = 39 [json_name = "stands_not_gps_confirmed"];
   */
  stands_not_gps_confirmed?: number;

  /**
   * @generated from field: optional int32 stands_not_visited = 40 [json_name = "stands_not_visited"];
   */
  stands_not_visited?: number;

  /**
   * @generated from field: optional float stands_visited_percent = 41 [json_name = "stands_visited_percent"];
   */
  stands_visited_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional int32 stands_climb_count = 42 [json_name = "stands_climb_count"];
   */
  stands_climb_count?: number;

  /**
   * @generated from field: optional int32 stands_visit_count = 43 [json_name = "stands_visit_count"];
   */
  stands_visit_count?: number;

  /**
   * Relationships
   *
   * @generated from field: repeated raccoonai.DistrictVolume district_volumes = 44 [json_name = "district_volumes"];
   */
  district_volumes?: DistrictVolumeJson[];

  /**
   * @generated from field: repeated raccoonai.ContainerStat container_stats = 45 [json_name = "container_stats"];
   */
  container_stats?: ContainerStatJson[];

  /**
   * @generated from field: repeated raccoonai.VisitPointStat visit_point_stats = 46 [json_name = "visit_point_stats"];
   */
  visit_point_stats?: VisitPointStatJson[];

  /**
   * The organization the row rolls up to (owner_organization_id resolved), so the caller
   * does not have to look the name up separately.
   *
   * @generated from field: optional raccoonai.Organization owner_organization = 47 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * The district organization whose geo access covers that organization, and that access's
   * area name. Both unset when the organization's branches span several districts - there is
   * no single district to name then.
   *
   * @generated from field: optional uint64 district_organization_id = 48 [json_name = "district_organization_id"];
   */
  district_organization_id?: string;

  /**
   * @generated from field: optional string district_name = 49 [json_name = "district_name"];
   */
  district_name?: string;
};

/**
 * Describes the message raccoonai.DailySummary.
 * Use `create(DailySummarySchema)` to create a new message.
 */
export const DailySummarySchema: GenMessage<DailySummary, {jsonType: DailySummaryJson}> = /*@__PURE__*/
  messageDesc(file_daily_summary, 4);

